
// import React, { useState, useEffect, useRef } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TextField,
//   Box,
//   IconButton,
//   CircularProgress,
//   Menu,
//   MenuItem,
//   Typography,
//   Divider,
//   Button,
//   Grid,
//   useMediaQuery,
//   useTheme,
//   Collapse,
// } from "@mui/material";
// import { Tooltip } from "@mui/material";
// import {
//   Description as FileIcon, ExpandMore,
//   ExpandLess,
// } from "@mui/icons-material";
// import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import { getAllItems, deleteItem, exportStockSummary } from "../../../Services/Services";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import InfiniteScroll from "react-infinite-scroll-component";
// import { useLocation } from "react-router-dom";

// export default function StockSummaryTable() {
//   const [items, setItems] = useState([]);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [excelLoading, setExcelLoading] = useState(false);

//   // 📅 Date Range States (NEW)
//   // ये जोड़ो
//   const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
//   const [tempCustomDateRange, setTempCustomDateRange] = useState({
//     from: "",
//     to: "",
//   });
//   const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const [expandedItem, setExpandedItem] = useState(null);

//   const [customDateRange, setCustomDateRange] = useState({
//     from: "",
//     to: "",
//   });

//   const [filters, setFilters] = useState({
//     item_code: "",
//     name: "",
//     category_name: "",
//     sub_category: "",
//     item_type: "",
//     date_range: "today", // ✅ Default today
//   });

//   // 📅 Date Display Helper Functions (NEW)
//   const getDateRangeDisplay = (rangeType) => {
//     const now = new Date();
//     const formatDate = (date) => {
//       const day = date.getDate().toString().padStart(2, "0");
//       const month = (date.getMonth() + 1).toString().padStart(2, "0");
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     };

//     switch (rangeType) {
//       case "today":
//         return formatDate(now);
//       case "yesterday":
//         const yesterday = new Date(now);
//         yesterday.setDate(yesterday.getDate() - 1);
//         return formatDate(yesterday);
//       case "this_week":
//         const weekStart = new Date(now);
//         weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
//         return `${formatDate(weekStart)} to ${formatDate(now)}`;
//       case "previous_week":
//         const prevWeekEnd = new Date(now);
//         prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
//         const prevWeekStart = new Date(prevWeekEnd);
//         prevWeekStart.setDate(prevWeekStart.getDate() - 6);
//         return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
//       case "this_month":
//         const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
//         return `${formatDate(monthStart)} to ${formatDate(now)}`;
//       case "current_year":
//         const yearStart = new Date(now.getFullYear(), 0, 1);
//         return `${formatDate(yearStart)} to ${formatDate(now)}`;
//       case "financial_year":
//         let fyStart;
//         if (now.getMonth() >= 3) {
//           fyStart = new Date(now.getFullYear(), 3, 1);
//         } else {
//           fyStart = new Date(now.getFullYear() - 1, 3, 1);
//         }
//         return `${formatDate(fyStart)} to ${formatDate(now)}`;
//       default:
//         return "";
//     }
//   };

// function formatOnlyDate(dateTimeString) {
//   if (!dateTimeString) return "N/A";

//   // Take only the date part (before T)
//   const datePart = dateTimeString.split("T")[0];  // "2025-12-02"

//   const [year, month, day] = datePart.split("-");

//   return `${day}-${month}-${year}`;
// }
//   const formatDateDisplay = (dateString) => {
//     if (!dateString) return "";
//     const [year, month, day] = dateString.split("-");
//     return `${day}-${month}-${year}`;
//   };

//   // 🔄 Reset Filters (NEW)
//   const handleReset = () => {
//     setFilters({
//       item_code: "",
//       name: "",
//       category_name: "",
//       sub_category: "",
//       item_type: "",
//       date_range: "today",
//     });
//     setCustomDateRange({ from: "", to: "" });
//     setCustomDateRange({ from: "", to: "" });
//     setTempCustomDateRange({ from: "", to: "" }); // ✅ Add this line
//     setShowCustomDateInputs(false); // ✅ Add this line

//   };

//   // ✅ Handle Custom Date Range Apply
//   const handleApplyCustomDateRange = () => {
//     if (tempCustomDateRange.from && tempCustomDateRange.to) {
//       setCustomDateRange({
//         from: tempCustomDateRange.from,
//         to: tempCustomDateRange.to,
//       });
//       setFilters((prev) => ({ ...prev, date_range: "custom" }));
//       setDateMenuAnchor(null);
//       setShowCustomDateInputs(false);
//     } else {
//       toast.warning("Please select both From and To dates");
//     }
//   };

//   // ✅ Handle Cancel Custom Date Range
//   const handleCancelCustomDateRange = () => {
//     setTempCustomDateRange({ from: "", to: "" });
//     setShowCustomDateInputs(false);
//   };

//   // ✅ Modified useEffect with Date Filters
//   useEffect(() => {
//     const handler = setTimeout(() => {
//       setPage(1);
//       const updatedFilters = {
//         ...filters,
//         from_date: customDateRange.from || "",
//         to_date: customDateRange.to || "",
//       };
//       fetchItems(1, false, updatedFilters);
//     }, 1000);

//     return () => clearTimeout(handler);
//   }, [filters, customDateRange]); // ✅ Added customDateRange dependency

//   const fetchItems = async (page = 1, append = false, filterValues = filters) => {
//     const data = await getAllItems(page, filterValues);

//     if (append) {
//       setItems((prev) => [...prev, ...data.results]);
//     } else {
//       setItems(data.results);
//     }

//     setHasMore(!!data.next);
//   };

//   const fetchMoreData = () => {
//     if (hasMore) {
//       const updatedFilters = {
//         ...filters,
//         from_date: customDateRange.from || "",
//         to_date: customDateRange.to || "",
//       };
//       fetchItems(page + 1, true, updatedFilters);
//       setPage((prev) => prev + 1);
//     }
//   };

//   // 📊 Modified Excel Export with Date Filters
//   const handleExcelExport = async () => {
//     setExcelLoading(true);
//     try {
//       const updatedFilters = {
//         ...filters,
//         from_date: customDateRange.from || "",
//         to_date: customDateRange.to || "",
//       };
//       const blob = await exportStockSummary(updatedFilters);

//       const url = window.URL.createObjectURL(blob);
//       const a = document.createElement("a");
//       a.href = url;
//       a.download = `Stock_Summary_${new Date().toISOString().split('T')[0]}.xlsx`;
//       document.body.appendChild(a);
//       a.click();
//       document.body.removeChild(a);
//       window.URL.revokeObjectURL(url);

//       toast.success("Excel downloaded successfully!");
//     } catch (error) {
//       console.error("Export error:", error);
//       toast.error("Failed to export Excel");
//     } finally {
//       setExcelLoading(false);
//     }
//   };

//   const location = useLocation();
//   const editData = location.state?.data || null;

//   useEffect(() => {
//     if (location.state?.edited) {
//       window.history.replaceState({}, document.title);
//     }
//   }, [location.state]);


//   useEffect(() => {
//     document.body.style.overflow = isMobile ? 'auto' : 'hidden';

//     return () => {
//       document.body.style.overflow = 'auto';
//     };
//   }, [isMobile]);

//   return (
//     <>
//       {/* ✅ Filters - Same as original */}
//       <Box
//         display="flex"
//         flexDirection={{ xs: "column", sm: "row" }}
//         alignItems={{ xs: "stretch", sm: "center" }}
//         sx={{
//           mt: -3,
//           pt: -3,
//           mb: 2,
//           width: "100%",
//           gap: 1,
//         }}
//       >
//         <ToastContainer position="top-right" autoClose={3000} />

//         {/* Date Range Selector */}
//         <TextField
//           label="Date Range"
//           value={
//             filters.date_range === "custom" &&
//               customDateRange.from &&
//               customDateRange.to
//               ? `${formatDateDisplay(customDateRange.from)} to ${formatDateDisplay(customDateRange.to)}`
//               : filters.date_range === "today"
//                 ? "Today"
//                 : filters.date_range === "yesterday"
//                   ? "Yesterday"
//                   : filters.date_range === "this_week"
//                     ? "This Week"
//                     : filters.date_range === "previous_week"
//                       ? "Previous Week"
//                       : filters.date_range === "this_month"
//                         ? "This Month"
//                         : filters.date_range === "current_year"
//                           ? "Current Year"
//                           : filters.date_range === "financial_year"
//                             ? "Financial Year"
//                             : "Select Date Range"
//           }
//           onClick={(e) => setDateMenuAnchor(e.currentTarget)}
//           size="small"
//           InputProps={{
//             readOnly: true,
//             endAdornment: (
//               <IconButton size="small" edge="end">
//                 <ArrowDropDownIcon />
//               </IconButton>
//             ),
//           }}
//           sx={{
//             cursor: "pointer",
//             width: "100%",
//             "& .MuiInputBase-root": {
//               height: 35,
//               fontSize: "0.7rem",
//               borderRadius: "0px",
//             },
//             "& .MuiInputLabel-root": {
//               fontSize: "0.7rem",
//             },
//           }}
//         />

//         <TextField
//           label="Category"
//           value={filters.category_name}
//           onChange={(e) =>
//             setFilters({ ...filters, category_name: e.target.value })
//           }
//           size="small"
//           sx={{
//             width: "100%",
//             "& .MuiInputBase-root": {
//               height: 35,
//               fontSize: "0.7rem",
//               borderRadius: "0px",
//             },
//             "& .MuiInputLabel-root": {
//               fontSize: "0.7rem",
//             },
//           }}
//         />

//         <TextField
//           label="Sub Category"
//           value={filters.sub_category}
//           onChange={(e) =>
//             setFilters({ ...filters, sub_category: e.target.value })
//           }
//           size="small"
//           sx={{
//             width: "100%",
//             "& .MuiInputBase-root": {
//               height: 35,
//               fontSize: "0.7rem",
//               borderRadius: "0px",
//             },
//             "& .MuiInputLabel-root": {
//               fontSize: "0.7rem",
//             },
//           }}
//         />

//         <TextField
//           label="Item Type"
//           value={filters.item_type}
//           onChange={(e) =>
//             setFilters({ ...filters, item_type: e.target.value })
//           }
//           size="small"
//           sx={{
//             width: "100%",
//             "& .MuiInputBase-root": {
//               height: 35,
//               fontSize: "0.7rem",
//               borderRadius: "0px",
//             },
//             "& .MuiInputLabel-root": {
//               fontSize: "0.7rem",
//             },
//           }}
//         />

//         <TextField
//           label="Item Name"
//           value={filters.name}
//           onChange={(e) => setFilters({ ...filters, name: e.target.value })}
//           size="small"
//           sx={{
//             width: "100%",
//             "& .MuiInputBase-root": {
//               height: 35,
//               fontSize: "0.7rem",
//               borderRadius: "0px",
//             },
//             "& .MuiInputLabel-root": {
//               fontSize: "0.7rem",
//             },
//           }}
//         />

//         {/* Reset Button */}
//         <Button
//           variant="contained"
//           color="primary"
//           size="small"
//           onClick={handleReset}
//           sx={{
//             height: "35px",
//             whiteSpace: "nowrap",
//             minWidth: "80px",
//             borderRadius: "0",
//             fontSize: "0.7rem",
//           }}
//         >
//           Reset
//         </Button>

//         {/* Excel Export Button */}
//         <Box sx={{ minWidth: "40px", display: "flex", alignItems: "center" }}>
//           <Tooltip title={excelLoading ? "Exporting..." : "Download Excel"} arrow>
//             <span>
//               <IconButton
//                 color="success"
//                 size="small"
//                 onClick={handleExcelExport}
//                 disabled={excelLoading}
//                 sx={{
//                   borderRadius: "4px",
//                   padding: "6px",
//                 }}
//               >
//                 {excelLoading ? (
//                   <CircularProgress size={20} color="inherit" />
//                 ) : (
//                   <FileIcon fontSize="small" />
//                 )}
//               </IconButton>
//             </span>
//           </Tooltip>
//         </Box>

//         {/* Date Range Menu - UPDATED */}
//         <Menu
//           anchorEl={dateMenuAnchor}
//           open={Boolean(dateMenuAnchor)}
//           onClose={() => {
//             setDateMenuAnchor(null);
//             setShowCustomDateInputs(false);
//             setTempCustomDateRange({ from: "", to: "" });
//           }}
//           PaperProps={{
//             sx: { width: 350, maxHeight: 500 },
//           }}
//         >
//           {/* Today */}
//           <MenuItem
//             onClick={() => {
//               setFilters((prev) => ({ ...prev, date_range: "today" }));
//               setCustomDateRange({ from: "", to: "" });
//               setDateMenuAnchor(null);
//               setShowCustomDateInputs(false);
//             }}
//           >
//             <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
//               <Typography variant="body2">Today</Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {getDateRangeDisplay("today")}
//               </Typography>
//             </Box>
//           </MenuItem>

//           {/* Yesterday */}
//           <MenuItem
//             onClick={() => {
//               setFilters((prev) => ({ ...prev, date_range: "yesterday" }));
//               setCustomDateRange({ from: "", to: "" });
//               setDateMenuAnchor(null);
//               setShowCustomDateInputs(false);
//             }}
//           >
//             <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
//               <Typography variant="body2">Yesterday</Typography>
//               <Typography variant="caption" color="text.secondary">
//                 {getDateRangeDisplay("yesterday")}
//               </Typography>
//             </Box>
//           </MenuItem>

//           {/* This Week */}
//           <MenuItem
//             onClick={() => {
//               setFilters((prev) => ({ ...prev, date_range: "this_week" }));
//               setCustomDateRange({ from: "", to: "" });
//               setDateMenuAnchor(null);
//               setShowCustomDateInputs(false);
//             }}
//           >
//             <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
//               <Typography variant="body2">This Week</Typography>
//               <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
//                 {getDateRangeDisplay("this_week")}
//               </Typography>
//             </Box>
//           </MenuItem>

//           {/* Previous Week */}
//           <MenuItem
//             onClick={() => {
//               setFilters((prev) => ({ ...prev, date_range: "previous_week" }));
//               setCustomDateRange({ from: "", to: "" });
//               setDateMenuAnchor(null);
//               setShowCustomDateInputs(false);
//             }}
//           >
//             <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
//               <Typography variant="body2">Previous Week</Typography>
//               <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
//                 {getDateRangeDisplay("previous_week")}
//               </Typography>
//             </Box>
//           </MenuItem>

//           {/* This Month */}
//           <MenuItem
//             onClick={() => {
//               setFilters((prev) => ({ ...prev, date_range: "this_month" }));
//               setCustomDateRange({ from: "", to: "" });
//               setDateMenuAnchor(null);
//               setShowCustomDateInputs(false);
//             }}
//           >
//             <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
//               <Typography variant="body2">This Month</Typography>
//               <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
//                 {getDateRangeDisplay("this_month")}
//               </Typography>
//             </Box>
//           </MenuItem>

//           {/* Current Year */}
//           <MenuItem
//             onClick={() => {
//               setFilters((prev) => ({ ...prev, date_range: "current_year" }));
//               setCustomDateRange({ from: "", to: "" });
//               setDateMenuAnchor(null);
//               setShowCustomDateInputs(false);
//             }}
//           >
//             <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
//               <Typography variant="body2">Current Year</Typography>
//               <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
//                 {getDateRangeDisplay("current_year")}
//               </Typography>
//             </Box>
//           </MenuItem>

//           {/* Financial Year */}
//           <MenuItem
//             onClick={() => {
//               setFilters((prev) => ({ ...prev, date_range: "financial_year" }));
//               setCustomDateRange({ from: "", to: "" });
//               setDateMenuAnchor(null);
//               setShowCustomDateInputs(false);
//             }}
//           >
//             <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
//               <Typography variant="body2">Financial Year</Typography>
//               <Typography variant="caption" color="text.secondary" sx={{ fontSize: "0.65rem" }}>
//                 {getDateRangeDisplay("financial_year")}
//               </Typography>
//             </Box>
//           </MenuItem>

//           <Divider />

//           {/* ✅ Custom Date Range - Expandable */}
//           <MenuItem
//             onClick={() => setShowCustomDateInputs(!showCustomDateInputs)}
//             sx={{
//               display: "flex",
//               justifyContent: "space-between",
//               alignItems: "center",
//               bgcolor: showCustomDateInputs ? "#e3f2fd" : "inherit",
//             }}
//           >
//             <Typography variant="body2" sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}>
//               Custom Date Range
//             </Typography>
//             {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
//           </MenuItem>

//           {/* ✅ Both Date Pickers Together */}
//           <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
//             <Box
//               sx={{
//                 px: 2,
//                 py: 2,
//                 bgcolor: "#f5f5f5",
//                 borderTop: "1px solid #e0e0e0",
//               }}
//               onClick={(e) => e.stopPropagation()}
//             >
//               <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: "block" }}>
//                 Select Date Range
//               </Typography>

//               {/* From and To Date Inputs Side by Side */}
//               <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
//                 <TextField
//                   label="From Date"
//                   type="date"
//                   size="small"
//                   value={tempCustomDateRange.from}
//                   onChange={(e) =>
//                     setTempCustomDateRange((prev) => ({
//                       ...prev,
//                       from: e.target.value,
//                     }))
//                   }
//                   InputLabelProps={{ shrink: true }}
//                   inputProps={{
//                     max: tempCustomDateRange.to || undefined,
//                   }}
//                   sx={{
//                     flex: 1,
//                     "& .MuiInputBase-root": {
//                       height: 40,
//                       fontSize: "0.75rem",
//                     },
//                     "& .MuiInputLabel-root": {
//                       fontSize: "0.75rem",
//                     },
//                   }}
//                 />

//                 <TextField
//                   label="To Date"
//                   type="date"
//                   size="small"
//                   value={tempCustomDateRange.to}
//                   onChange={(e) =>
//                     setTempCustomDateRange((prev) => ({
//                       ...prev,
//                       to: e.target.value,
//                     }))
//                   }
//                   InputLabelProps={{ shrink: true }}
//                   inputProps={{
//                     min: tempCustomDateRange.from || undefined,
//                   }}
//                   sx={{
//                     flex: 1,
//                     "& .MuiInputBase-root": {
//                       height: 40,
//                       fontSize: "0.75rem",
//                     },
//                     "& .MuiInputLabel-root": {
//                       fontSize: "0.75rem",
//                     },
//                   }}
//                 />
//               </Box>

//               {/* Selected Range Preview */}
//               {tempCustomDateRange.from && tempCustomDateRange.to && (
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     display: "block",
//                     mb: 1.5,
//                     p: 1,
//                     bgcolor: "#e8f5e9",
//                     borderRadius: 1,
//                     textAlign: "center",
//                     color: "#2e7d32",
//                     fontWeight: 500,
//                   }}
//                 >
//                   📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
//                   {formatDateDisplay(tempCustomDateRange.to)}
//                 </Typography>
//               )}

//               {/* Apply and Cancel Buttons */}
//               <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
//                 <Button
//                   variant="outlined"
//                   size="small"
//                   onClick={handleCancelCustomDateRange}
//                   sx={{
//                     fontSize: "0.7rem",
//                     textTransform: "none",
//                     borderRadius: 1,
//                   }}
//                 >
//                   Cancel
//                 </Button>
//                 <Button
//                   variant="contained"
//                   size="small"
//                   onClick={handleApplyCustomDateRange}
//                   disabled={!tempCustomDateRange.from || !tempCustomDateRange.to}
//                   sx={{
//                     fontSize: "0.7rem",
//                     textTransform: "none",
//                     borderRadius: 1,
//                   }}
//                 >
//                   Apply
//                 </Button>
//               </Box>
//             </Box>
//           </Collapse>
//         </Menu>
//       </Box>

//       {/* ✅ Mobile/Desktop Conditional Rendering */}
//       <InfiniteScroll
//         dataLength={items.length}
//         next={fetchMoreData}
//         hasMore={hasMore}
//         loader={<h4>Loading...</h4>}
//         endMessage={<p style={{ textAlign: "center" }}>No more items!</p>}
//       >
//         {isMobile ? (
//           /* 📱 MOBILE VIEW - Collapsible Cards */
//           <Box sx={{ bgcolor: "background.paper" }}>
//             {items.map((item, index) => (
//               <Box key={index}>
//                 <Box
//                   onClick={() =>
//                     setExpandedItem(
//                       expandedItem === item.id ? null : item.id
//                     )
//                   }
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "space-between",
//                     p: 1.5,
//                     cursor: "pointer",
//                     bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
//                     "&:active": { bgcolor: "#e3f2fd" },
//                     borderLeft: "4px solid #2196f3",
//                   }}
//                 >
//                   <Box sx={{ flex: 1 }}>
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                         mb: 0.5,
//                       }}
//                     >
//                       <Typography
//                         sx={{ fontSize: "0.7rem", color: "#666", minWidth: 25 }}
//                       >
//                         #{index + 1}
//                       </Typography>
//                       <Typography
//                         sx={{ fontWeight: "bold", fontSize: "0.85rem", flex: 1 }}
//                       >
//                         {item.item_code}
//                       </Typography>
//                     </Box>
//                     <Typography
//                       sx={{
//                         fontSize: "0.75rem",
//                         color: "#666",
//                         display: "flex",
//                         alignItems: "center",
//                         gap: 1,
//                       }}
//                     >
//                       <span style={{ fontWeight: 500 }}>
//                         {item.name || "N/A"}
//                       </span>
//                       <span style={{ color: "#999" }}>•</span>
//                       <span style={{ fontSize: "0.7rem" }}>
//                         {item.category_name}
//                       </span>
//                     </Typography>
//                   </Box>
//                   <IconButton size="small" sx={{ ml: 1 }}>
//                     {expandedItem === item.id ? (
//                       <ExpandLess fontSize="small" />
//                     ) : (
//                       <ExpandMore fontSize="small" />
//                     )}
//                   </IconButton>
//                 </Box>

//                 <Collapse
//                   in={expandedItem === item.id}
//                   timeout="auto"
//                   unmountOnExit
//                 >
//                   <Box
//                     sx={{
//                       px: 1.5,
//                       py: 1,
//                       bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
//                       borderLeft: "4px solid #2196f3",
//                     }}
//                   >
//                     <Box
//                       sx={{
//                         display: "grid",
//                         gridTemplateColumns: "1fr 1fr",
//                         gap: 0.8,
//                         mb: 1,
//                       }}
//                     >
//                       <Box sx={{ gridColumn: "1 / -1" }}>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           ITEM NAME
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.75rem",
//                             fontWeight: 500,
//                             color: "#333",
//                           }}
//                         >
//                           {item.name || "-"}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           CATEGORY
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 500,
//                             color: "#555",
//                           }}
//                         >
//                           {item.category_name || "-"}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           SUB CATEGORY
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 500,
//                             color: "#555",
//                           }}
//                         >
//                           {item.subcategory_name || "-"}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           ITEM TYPE
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 500,
//                             color: "#555",
//                           }}
//                         >
//                           {item.item_type || "-"}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           UNIT
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 500,
//                             color: "#555",
//                           }}
//                         >
//                           {item.unit_name || "-"}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           OPENING STOCK
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 600,
//                             color: "#1976d2",
//                           }}
//                         >
//                           {item.opening_qty || 0}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           INWARD QTY
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 600,
//                             color: "#4caf50",
//                           }}
//                         >
//                           {item.inward_qty || 0}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           OUTWARD QTY
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 600,
//                             color: "#ff9800",
//                           }}
//                         >
//                           {item.out_qty || 0}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           CLOSING STOCK
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 600,
//                             color: "#f44336",
//                           }}
//                         >
//                           {item.current_stock || 0}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           RATE
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 600,
//                             color: "#9c27b0",
//                           }}
//                         >
//                           ₹ {item.rate || 0}
//                         </Typography>
//                       </Box>

//                       <Box>
//                         <Typography
//                           sx={{
//                             fontSize: "0.6rem",
//                             color: "#999",
//                             letterSpacing: "0.5px",
//                           }}
//                         >
//                           DATE
//                         </Typography>
//                         <Typography
//                           sx={{
//                             fontSize: "0.72rem",
//                             fontWeight: 500,
//                             color: "#555",
//                           }}
//                         >
//                           {formatOnlyDate(item.created_at)}
//                         </Typography>
//                       </Box>
//                     </Box>
//                   </Box>
//                 </Collapse>
//                 <Divider />
//               </Box>
//             ))}
//           </Box>
//         ) : (
//           /* 💻 DESKTOP VIEW - Original Table */
//           <TableContainer
//             component={Paper}
//             id="item-table"
//             sx={{
//               maxHeight: "88vh",
//               overflowX: { xs: "auto", sm: "unset" },
//               overflowY: "auto",
//               width: "100%",
//             }}
//           >
//             <Table
//               stickyHeader
//               size="small"
//               sx={{
//                 minWidth: "max-content",
//                 "& td, & th": {
//                   borderBottom: "1px solid #ccc",
//                   textAlign: "center",
//                   whiteSpace: "nowrap",
//                   backgroundColor: "#f5f5f5",
//                 },
//               }}
//             >
//               <TableHead
//                 sx={{
//                   "& th": {
//                     fontWeight: "bold",
//                     color: (theme) =>
//                       theme.palette.mode === "dark" ? "#2196f3" : "#333",
//                     backgroundColor: (theme) =>
//                       theme.palette.mode === "dark" ? "black" : "#f5f5f5",
//                   },
//                 }}
//               >
//                 <TableRow>
//                   <TableCell
//                     sx={{
//                       position: "sticky",
//                       left: 0,
//                       backgroundColor: "#f5f5f5",
//                       zIndex: 3,
//                       minWidth: 60,
//                       padding: "0px",
//                     }}
//                   >
//                     S. No.
//                   </TableCell>

//                   <TableCell
//                     sx={{
//                       position: "sticky",
//                       left: 49,
//                       backgroundColor: "#f5f5f5",
//                       zIndex: 3,
//                       minWidth: 80,
//                     }}
//                   >
//                     Item Code
//                   </TableCell>
//                   <TableCell>Category</TableCell>
//                   <TableCell>Sub Category</TableCell>
//                   <TableCell>Item Type</TableCell>
//                   <TableCell>Name</TableCell>
//                   <TableCell>Unit</TableCell>
//                   <TableCell align="right">Opening Stock</TableCell>
//                   <TableCell align="right">Inward Qty</TableCell>
//                   <TableCell>Outward Qty</TableCell>
//                   <TableCell>Closing Stock</TableCell>
//                   <TableCell align="right">Rate</TableCell>
//                   <TableCell align="right">Date</TableCell>
//                 </TableRow>
//               </TableHead>

//               <TableBody>
//                 {items.map((item, index) => (
//                   <TableRow
//                     hover
//                     key={index}
//                     sx={{
//                       backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
//                       "&:hover": {
//                         backgroundColor: "#e3f2fd",
//                         "& td": { backgroundColor: "#e3f2fd !important" },
//                       },
//                       "& td": {
//                         paddingTop: "2px !important",
//                         paddingBottom: "2px !important",
//                         fontSize: { xs: "0.75rem", sm: "0.8125rem" },
//                         whiteSpace: "nowrap",
//                         overflow: "hidden",
//                         textOverflow: "ellipsis",
//                         color: (theme) =>
//                           theme.palette.mode === "dark" ? "white" : "inherit",
//                         backgroundColor: (theme) =>
//                           theme.palette.mode === "dark" ? "black" : "inherit",
//                       },
//                     }}
//                   >
//                     <TableCell
//                       align="center"
//                       sx={{
//                         position: "sticky",
//                         left: 0,
//                         backgroundColor: "#fafafa",
//                         zIndex: 2,
//                         minWidth: 60,
//                       }}
//                     >
//                       {index + 1}
//                     </TableCell>

//                     <TableCell
//                       sx={{
//                         position: "sticky",
//                         left: 40,
//                         backgroundColor: "#fafafa",
//                         zIndex: 2,
//                         minWidth: 80,
//                       }}
//                     >
//                       {item.item_code}
//                     </TableCell>

//                     <TableCell>{item.category_name}</TableCell>
//                     <TableCell>{item.subcategory_name}</TableCell>
//                     <TableCell>{item.item_type}</TableCell>
//                     <TableCell>{item.name}</TableCell>
//                     <TableCell align="right">{item.unit_name}</TableCell>
//                     <TableCell align="right">{item.opening_qty}</TableCell>
//                     <TableCell>{item.inward_qty}</TableCell>
//                     <TableCell>{item.out_qty}</TableCell>
//                     <TableCell align="right">{item.current_stock}</TableCell>
//                     <TableCell align="right">{item.rate}</TableCell>
//                     <TableCell align="right">
//                       {formatOnlyDate(item.created_at)}
//                     </TableCell>
//                   </TableRow>
//                 ))}
//               </TableBody>
//             </Table>
//           </TableContainer>
//         )}
//       </InfiniteScroll>
//     </>
//   );
// }

import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Typography,
  Stack,
  Popover,
  Grid,
  Menu,
  Collapse,
  Divider,
  Autocomplete,
  CircularProgress
} from "@mui/material";
import { Edit, Delete as DeleteIcon, Visibility } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { ExpandMore, ExpandLess } from '@mui/icons-material';

import { getAllItems, deleteItem, getCategories, fetchSubCategories, getSizes, ItemListExport } from "../../../Services/Services";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import InfiniteScroll from "react-infinite-scroll-component";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useMediaQuery, useTheme } from "@mui/material";
import { debounce } from "lodash";
import { useLocation } from "react-router-dom";
import { Description as FileIcon } from "@mui/icons-material";  // ✅ ADD THIS
import { Tooltip } from "@mui/material";

export default function ItemTable() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [expandedItem, setExpandedItem] = useState(null);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [sizes, setSizes] = useState([]);
  const [excelLoading, setExcelLoading] = useState(false);  // ✅ ADD THIS


  const [filters, setFilters] = useState({
    item_code: "",
    name: "",
    store_item_type: "",
    category: null,
    sub_category: null,
    size: null,
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedPO, setExpandedPO] = useState(null);


  // ✅ Check if any filter is applied (internal)
  const isAnyFilterApplied = () => {
    return (
      filters.category !== null ||
      filters.sub_category !== null ||
      filters.size !== null ||
      filters.name.trim() !== "" ||
      filters.item_code.trim() !== ""
    );
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1); // reset page
      fetchItems(1, false); // reset data with new filters
    }, 1000);

    return () => clearTimeout(handler);
  }, [filters]);

  const fetchItems = async (page = 1, append = false) => {
    const effectiveDateRange = isAnyFilterApplied() ? "all" : "today";
    const apiFilters = {
      item_code: filters.item_code,
      name: filters.name,
      store_item_type: filters.store_item_type,
      category: filters.category?.name || "",           // ✅ NAME-based
      sub_category: filters.sub_category?.name || "",   // ✅ NAME-based
      item_size: filters.size?.id || "",
      date_range: effectiveDateRange,
    };
    const data = await getAllItems(page, apiFilters);

    if (append) {
      setItems((prev) => [...prev, ...data.results]);
    } else {
      setItems(data.results);
    }

    setHasMore(!!data.next);
  };

  const fetchMoreData = () => {
    if (hasMore) {
      fetchItems(page + 1, true); // ✅ append mode
      setPage((prev) => prev + 1);
    }
  };
  const location = useLocation();
  const editData = location.state?.data || null;

  useEffect(() => {
    if (location.state?.edited) {
      // Clear the navigation state so toast doesn't repeat on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location.state]);

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleDelete = async (id) => {
    try {
      await deleteItem(id); // assume it just confirms deletion
      setItems((prev) => prev.filter((item) => item.id !== id)); // use passed `id`
      toast.success("Deleted successfully");
    } catch (err) {
      toast.error("Failed to delete");
    }
  };

  function formatOnlyDate(dateTimeString) {
    if (!dateTimeString) return "N/A";

    // Take only the date part (before T)
    const datePart = dateTimeString.split("T")[0];  // "2025-12-02"

    const [year, month, day] = datePart.split("-");

    return `${day}-${month}-${year}`;
  }


  // ✅ NEW: Fetch categories on mount
  useEffect(() => {
    fetchCategoriesData();
    fetchSizesData();
  }, []);

  const fetchCategoriesData = async (search = "") => {
    try {
      const data = await getCategories(1, search);
      setCategories(Array.isArray(data) ? data : data?.results || []);
    } catch (error) {
    }
  };

  const fetchSubcategoriesData = async (categoryId, search = "") => {
    if (!categoryId) {
      setSubcategories([]);
      return;
    }
    try {
      const data = await fetchSubCategories(categoryId, 1, search);
      setSubcategories(Array.isArray(data) ? data : data?.results || []);
    } catch (error) {
      // console.error("Error fetching subcategories:", error);
      setSubcategories([]);
    }
  };

  // ✅ NEW: Fetch sizes with search
  const fetchSizesData = async (search = "") => {
    try {
      const data = await getSizes(search);
      setSizes(Array.isArray(data) ? data : data?.results || []);
    } catch (error) {
      console.error("Error fetching sizes:", error);
    }
  };


  // ✅ Debounced search handlers
  const handleCategorySearch = debounce((searchValue) => {
    fetchCategoriesData(searchValue);
  }, 500);

  const handleSubcategorySearch = debounce((searchValue) => {
    if (filters.category) {
      fetchSubcategoriesData(filters.category.id, searchValue); // ✅ Use correct function
    }
  }, 500);

  // ✅ NEW: Size search handler
  const handleSizeSearch = debounce((searchValue) => {
    fetchSizesData(searchValue);
  }, 500);

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchItems(1, false);
    }, 1000);

    return () => clearTimeout(handler);
  }, [filters]);


  // ✅ Excel Export Handler
  const handleExcelExport = async () => {
    setExcelLoading(true);
    try {
      // Prepare filters for API

       const effectiveDateRange = isAnyFilterApplied() ? "all" : "today";
      const apiFilters = {
        item_code: filters.item_code || "",
        name: filters.name || "",
        category_name: filters.category?.name || "",
        sub_category: filters.sub_category?.name || "",
        item_size: filters.size?.size || "",
         date_range: effectiveDateRange,  // ✅ Same as table
      };

      const blob = await ItemListExport(apiFilters);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Item_List_${new Date().toISOString().split("T")[0]}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      toast.success("Excel downloaded successfully!");
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Failed to export Excel");
    } finally {
      setExcelLoading(false);
    }
  };


  useEffect(() => {
    document.body.style.overflow = isMobile ? 'auto' : 'hidden';

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isMobile]);
  return (
    <>
      {/* Filters & Add Item Button */}
      <Box
        display="flex"
        flexDirection={{ xs: "column", sm: "row" }} // stack on mobile
        alignItems={{ xs: "stretch", sm: "center" }} // stretch inputs on mobile
        sx={{
          mt: -3,
          pt: -3,
          mb: 1,
          width: "100%",
          gap: 2, // spacing between items
        }}
      >
        <ToastContainer position="top-right" autoClose={3000} />


        {/* ✅ CATEGORY AUTOCOMPLETE */}
        <Autocomplete
          options={categories}
          getOptionLabel={(option) => option?.name || ""}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          value={filters.category}
          onChange={(e, newValue) => {
            setFilters({
              ...filters,
              category: newValue,
              sub_category: null, // Reset subcategory
            });
            if (newValue) {
              fetchSubcategoriesData(newValue.id); // ✅ Fetch subcategories
            } else {
              setSubcategories([]); // ✅ Clear subcategories
            }
          }}
          onInputChange={(e, newValue, reason) => {
            if (reason === "input") {
              handleCategorySearch(newValue);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Category"
              size="small"
              sx={{
                width: { xs: "100%", sm: "225px" },
                "& .MuiInputBase-root": {
                  height: 30,
                  fontSize: "0.7rem",
                  borderRadius: "0px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          )}
        />

        {/* ✅ SUBCATEGORY AUTOCOMPLETE */}
        {/* <Autocomplete
          options={subcategories}
          getOptionLabel={(option) => option?.name || ""}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          value={filters.sub_category}
          disabled={!filters.category}
          onChange={(e, newValue) => {
            setFilters({ ...filters, sub_category: newValue });
          }}
          onInputChange={(e, newValue, reason) => {
            if (reason === "input") {
              handleSubcategorySearch(newValue);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Sub Category"
              size="small"
              sx={{
                width: { xs: "100%", sm: "225px" },
                "& .MuiInputBase-root": {
                  height: 30,
                  fontSize: "0.7rem",
                  borderRadius: "0px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          )}
        /> */}

        {/* ✅ SIZE AUTOCOMPLETE */}
        <Autocomplete
          options={sizes}
          getOptionLabel={(option) => option?.size || ""}
          isOptionEqualToValue={(option, value) => option.id === value?.id}
          value={filters.size}
          onChange={(e, newValue) => {
            setFilters({ ...filters, size: newValue });
          }}
          onInputChange={(e, newValue, reason) => {
            if (reason === "input") {
              handleSizeSearch(newValue);
            }
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Size"
              size="small"
              sx={{
                width: { xs: "100%", sm: "225px" },
                "& .MuiInputBase-root": {
                  height: 30,
                  fontSize: "0.7rem",
                  borderRadius: "0px",
                },
                "& .MuiInputLabel-root": {
                  fontSize: "0.7rem",
                },
              }}
            />
          )}
        />

        <TextField
          label="Item Name"
          value={filters.name}
          onChange={(e) => setFilters({ ...filters, name: e.target.value })}
          size="small"
          sx={{
            width: { xs: "100%", sm: "225px" },
            "& .MuiInputBase-root": {
              height: 30,
              fontSize: "0.7rem",
              borderRadius: "0px",
            },
            "& .MuiInputLabel-root": {
              fontSize: "0.7rem",
            },
          }}
        />

        {/* Right side buttons */}
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          gap={2}
          ml={{ xs: 0, sm: "auto" }}
          width={{ xs: "100%", sm: "auto" }}
        >
          <Button
            variant="contained"
            color="primary"
            size="small" // ✅ button bhi chhota
            startIcon={<AddIcon sx={{ fontSize: 18 }} />} // ✅ icon chhota
            fullWidth={{ xs: true, sm: false }}
            onClick={() =>
              navigate("/dashboard/item-form", {
                state: { mode: "create" },
              })
            }
            sx={{
              height: 30, // ✅ same height as inputs
              fontSize: "0.7rem", // ✅ text chhota
              padding: "2px 15px",
              borderRadius: "0px",
            }}
          >
            Item
          </Button>
        </Box>

        {/* ✅ Excel Export Button */}
        <Tooltip title={excelLoading ? "Exporting..." : "Download Excel"} arrow>
          <span>
            <IconButton
              color="success"
              size="small"
              onClick={handleExcelExport}
              disabled={excelLoading}
              sx={{
                borderRadius: "4px",
                padding: "6px",
                border: "1px solid #4caf50",
                "&:hover": {
                  backgroundColor: "#e8f5e9",
                },
              }}
            >
              {excelLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                <FileIcon fontSize="small" />
              )}
            </IconButton>
          </span>
        </Tooltip>
        {/* Add more buttons here if needed */}
      </Box>

      <InfiniteScroll
        dataLength={items.length}
        next={fetchMoreData}
        hasMore={hasMore}
        // height={isMobile ? "75vh" : "80vh"}
        loader={<h4>Loading...</h4>}
        endMessage={
          <Typography sx={{ textAlign: "center", py: 2, color: "#999" }}>
            No more items!
          </Typography>
        }
      >
        {isMobile ? (
          /* 📱 MOBILE VIEW - Expandable List */
          <Box sx={{ bgcolor: "background.paper" }}>
            {items.map((item, index) => (
              <Box key={item.id || index}>
                {/* Main Row - Always Visible */}
                <Box
                  onClick={() =>
                    setExpandedItem(expandedItem === item.id ? null : item.id)
                  }
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 1.5,
                    cursor: "pointer",
                    bgcolor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                    "&:active": {
                      bgcolor: "#e3f2fd",
                    },
                    borderLeft: "4px solid #1976d2",
                  }}
                >
                  {/* Left Side - Main Info */}
                  <Box sx={{ flex: 1 }}>
                    {/* S.No + Item Code */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        mb: 0.5,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#666",
                          minWidth: 25,
                        }}
                      >
                        {index + 1}
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.85rem",
                          flex: 1,
                        }}
                      >
                        {item.item_code}
                      </Typography>
                    </Box>

                    {/* Item Name */}
                    <Typography
                      sx={{
                        fontSize: "0.7rem",
                        color: "#666",
                        ml: 4,
                      }}
                    >
                      {item.name?.substring(0, 30) || "N/A"}
                    </Typography>
                  </Box>

                  {/* Expand Icon */}
                  <IconButton size="small" sx={{ ml: 1 }}>
                    {expandedItem === item.id ? (
                      <ExpandLess fontSize="small" />
                    ) : (
                      <ExpandMore fontSize="small" />
                    )}
                  </IconButton>
                </Box>

                {/* Expanded Details */}
                <Collapse
                  in={expandedItem === item.id}
                  timeout="auto"
                  unmountOnExit
                >
                  <Box
                    sx={{
                      px: 1.5,
                      py: 1,
                      bgcolor: index % 2 === 0 ? "#f8f9fa" : "#fafafa",
                      borderLeft: "4px solid #1976d2",
                    }}
                  >
                    {/* Detailed Info - 2 Column Grid */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 1,
                      }}
                    >
                      {/* Item Code */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          ITEM CODE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {item.item_code}
                        </Typography>
                      </Box>

                      {/* Item Type */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          ITEM TYPE
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {item.store_item_type_name}
                        </Typography>
                      </Box>

                      {/* Min Quantity */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          MIN QUANTITY
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {item.min_quantity}
                        </Typography>
                      </Box>

                      {/* Current Stock */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          CURRENT STOCK
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {item.current_stock}
                        </Typography>
                      </Box>
                    </Box>

                    {/* Item Name - Full Width */}
                    <Box sx={{ mb: 0.8 }}>
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          color: "#999",
                          letterSpacing: "0.5px",
                          mb: 0.3,
                        }}
                      >
                        ITEM NAME
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#555",
                          lineHeight: 1.3,
                          fontWeight: 500,
                        }}
                      >
                        {item.name}
                      </Typography>
                    </Box>

                    {/* Category - Full Width */}
                    {/* <Box sx={{ mb: 0.8 }}>
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          color: "#999",
                          letterSpacing: "0.5px",
                          mb: 0.3,
                        }}
                      >
                        CATEGORY
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#555",
                          lineHeight: 1.3,
                        }}
                      >
                        {item.category_name}
                      </Typography>
                    </Box> */}

                    {/* Sub Category - Full Width */}
                    {/* <Box sx={{ mb: 0.8 }}>
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          color: "#999",
                          letterSpacing: "0.5px",
                          mb: 0.3,
                        }}
                      >
                        SUB CATEGORY
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.7rem",
                          color: "#555",
                          lineHeight: 1.3,
                        }}
                      >
                        {item.subcategory_name}
                      </Typography>
                    </Box> */}

                    {/* Created Info - 2 Column */}
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: 0.8,
                        mb: 0.8,
                      }}
                    >
                      {/* Created By */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          CREATED BY
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {item.created_by_name || "N/A"}
                        </Typography>
                      </Box>

                      {/* Created At */}
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "0.6rem",
                            color: "#999",
                            letterSpacing: "0.5px",
                          }}
                        >
                          CREATED AT
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.72rem",
                            fontWeight: 500,
                            color: "#555",
                          }}
                        >
                          {formatOnlyDate(item.created_at)}
                        </Typography>
                      </Box>
                    </Box>

                    <Divider sx={{ my: 1, borderColor: "#e0e0e0" }} />

                    {/* Action Buttons */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: 1,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          color: "#999",
                          fontWeight: 600,
                          letterSpacing: "0.5px",
                        }}
                      >
                        ACTIONS
                      </Typography>

                      {/* Edit & Delete Buttons */}
                      <Box sx={{ display: "flex", gap: 0.6 }}>
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate("/dashboard/item-form", {
                              state: { mode: "edit", data: item },
                            });
                          }}
                          sx={{
                            bgcolor: "#e3f2fd",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#bbdefb",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <Edit sx={{ fontSize: "1rem", color: "#1976d2" }} />
                        </IconButton>

                        <IconButton
                          size="small"
                          onClick={(e) => {
                            e.stopPropagation();
                            setAnchorEl(e.currentTarget);
                            setItemToDelete(item.id);
                          }}
                          sx={{
                            bgcolor: "#ffebee",
                            borderRadius: "6px",
                            width: 32,
                            height: 32,
                            "&:hover": {
                              bgcolor: "#ffcdd2",
                              transform: "scale(1.05)",
                            },
                            transition: "all 0.2s",
                          }}
                        >
                          <DeleteIcon
                            sx={{ fontSize: "1rem", color: "#d32f2f" }}
                          />
                        </IconButton>
                      </Box>
                    </Box>
                  </Box>
                </Collapse>

                {/* Divider between items */}
                <Divider />
              </Box>
            ))}
          </Box>
        ) : (
          /* 💻 DESKTOP VIEW - Table */
          <TableContainer
            component={Paper}
            id="item-table"
            sx={{
              maxHeight: "88vh",
              overflowX: "auto",
              overflowY: "auto",
              width: "100%",
            }}
          >
            <Table
              stickyHeader
              size="small"
              sx={{
                minWidth: 1270,
                "& td, & th": {
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  borderBottom: "1px solid #ccc",
                },
              }}
            >
              <TableHead
                sx={{
                  "& th": {
                    fontWeight: "bold",
                    fontsize: "0.75rem",
                    color: (theme) =>
                      theme.palette.mode === "dark" ? "#2196f3" : "#333",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark" ? "black" : "#f5f5f5",
                  },
                }}
              >
                <TableRow>
                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 50,
                      padding: "0px",
                    }}
                  >
                    S. No.
                  </TableCell>

                  <TableCell
                    sx={{
                      position: "sticky",
                      left: 40,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 80,
                    }}
                  >
                    Code
                  </TableCell>

                  {/* <TableCell>Category</TableCell> */}
                  {/* <TableCell>Sub Category</TableCell> */}
                  <TableCell>Item Name</TableCell>
                  {/* <TableCell>Item Type</TableCell> */}
                  <TableCell>Prduct Type</TableCell>

                  <TableCell align="right">Min Quantity</TableCell>
                  <TableCell align="right">Current Stock</TableCell>
                  <TableCell align="right">Created by</TableCell>
                  <TableCell align="right">Created at</TableCell>
                  <TableCell>Item Description</TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      position: "sticky",
                      right: 0,
                      backgroundColor: "#f5f5f5",
                      zIndex: 3,
                      minWidth: 80,
                    }}
                  >
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {items.map((item, index) => (
                  <TableRow
                    hover
                    key={index}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "#fafafa" : "#ffffff",
                      "&:hover": {
                        backgroundColor: "#e3f2fd",
                        "& td": { backgroundColor: "#e3f2fd !important" },
                      },
                      "& td": {
                        paddingRight: "13px !important",
                        paddingLeft: "13px !important",
                        padding: "0px",
                        fontSize: { xs: "0.65rem", sm: "0.75rem" },
                        whiteSpace: "nowrap",
                        color: (theme) =>
                          theme.palette.mode === "dark" ? "white" : "inherit",
                        backgroundColor: (theme) =>
                          theme.palette.mode === "dark" ? "black" : "inherit",
                      },
                    }}
                  >
                    <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        left: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 2,
                        minWidth: 50,
                      }}
                    >
                      {index + 1}
                    </TableCell>

                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 40,
                        backgroundColor: "#fafafa",
                        zIndex: 2,
                        minWidth: 80,
                      }}
                    >
                      {item.item_code}
                    </TableCell>

                    {/* <TableCell>{item.category_name}</TableCell> */}
                    {/* <TableCell>{item.subcategory_name}</TableCell> */}
                    <TableCell>{item.name}</TableCell>
                    {/* <TableCell>{item.store_item_type_name}</TableCell> */}
                    <TableCell>{item.size_name}</TableCell>

                    <TableCell align="right">{item.min_quantity}</TableCell>
                    <TableCell align="right">{item.current_stock}</TableCell>
                    <TableCell align="right">{item.created_by_name}</TableCell>
                    <TableCell align="right">
                      {formatOnlyDate(item.created_at)}
                    </TableCell>
                    <TableCell>{item.item_description}</TableCell>
                    <TableCell
                      align="center"
                      className="no-print"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fafafa",
                        zIndex: 2,
                        minWidth: 80,
                      }}
                    >
                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        size="small"
                        color="primary"
                        onClick={() =>
                          navigate("/dashboard/item-form", {
                            state: { mode: "edit", data: item },
                          })
                        }
                      >
                        <Edit transform="scale(0.6)" />
                      </IconButton>
                      <IconButton
                        sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                        size="small"
                        color="error"
                        onClick={(e) => {
                          setAnchorEl(e.currentTarget);
                          setItemToDelete(item.id);
                        }}
                      >
                        <DeleteIcon transform="scale(0.6)" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </InfiniteScroll>

      {/* Popover - Outside InfiniteScroll */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => {
          setAnchorEl(null);
          setItemToDelete(null);
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="body2">Are you sure?</Typography>
          <Box display="flex" justifyContent="flex-end" mt={1} gap={1}>
            <Button
              color="error"
              size="small"
              onClick={async () => {
                await handleDelete(itemToDelete);
                setAnchorEl(null);
                setItemToDelete(null);
              }}
            >
              Yes
            </Button>
            <Button size="small" onClick={() => setAnchorEl(null)}>
              No
            </Button>
          </Box>
        </Box>
      </Popover>
    </>
  );
}

